import { Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMentionsWithoutAccess } from 'app/domains/documents';
import { ListButton } from '../ListButton';
export function AccessButton() {
    const { hasMentionsWithoutAccess, usersMentionedWithoutAccess } = useMentionsWithoutAccess();
    return (<ListButton settingsKey="access" icon={<Falcon icon="lock"/>} endElement={hasMentionsWithoutAccess && (<Chip appearance="warning" label={usersMentionedWithoutAccess.length}/>)}/>);
}
